<script>
  import ReportingArticle from 'src/pc/pages/ReportingArticle'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import ReportInfo from '../components/ReportInfo'
  export default {
    extends: ReportingArticle,
    data () {
      return {
        isHidden: true
      }
    },
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      ReportInfo
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .reporting_article .con_wrapper {
    width: 100%;
    padding-top: 25px;
    padding-bottom: 50px;
  }
  .reporting_article .report .data {
    padding-bottom: 22px;
    margin-bottom: 25px;
  }
  .reporting_article .report .subj {
    font-size: 21px;
    font-weight: 600;
    letter-spacing: -.015em !important;
  }
  .reporting_article .report .date_area {
    font-size: 11px;
    margin-top: 20px;
    padding-top: 30px;
    position: relative;
  }
  .reporting_article .report .date_area .date:after {
    content: "" !important;
  }
  .reporting_article .report .date_area .level {
    display: block;
  }
  .reporting_article .report .date_area .editor {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    margin-left: 0;
  }
  .reporting_article .report .date_area .editor .img {
    width: 22px;
    height: 22px;
    transform: translateY(-2px);
  }
  .reporting_article .report .date_area .editor .name {
    padding-left: 7px;
  }
  .reporting_article .report .detail_con .con_view {
    font-size: 15px;
    line-height: 1.8em;
    padding-bottom: 50px;
  }
  .reporting_article .report .detail_con .copy {
    line-height: 1.6em;
  }
  .reporting_article .report .detail_con .copy span {
    display: block;
  }
  .reporting_article .report .detail_con .tag {
    position: relative;
    padding-left: 50px;
  }
  .reporting_article .report .detail_con .tag .h_tags  {
    font-size: 13px;
    line-height: 1.0em;
  }
  .reporting_article .report .detail_con .tag .h_tags .tit {
    font-weight: 700;
  }
  .reporting_article .report .detail_con .tag .h_tags a {
    margin: 0 10px 12px;
  }

  .reporting_article .report .detail_con .editor {
    padding: 25px 15px 25px 75px;
    font-size: 12px;
    margin: 25px 0;
    display: inline-flex;
    width: 100%;
    flex-direction: column;
  }
  .reporting_article .report .detail_con .editor .img {
    position: absolute;
    top: 50%;
    left: 25px;
    transform: translate(0, -50%);
  }
  .reporting_article .report .detail_con .editor .img img {
    width: 35px;
    height: 35px;
  }
  .reporting_article .report .detail_con .editor p {
    margin: 0;
  }
  .reporting_article .report .detail_con .editor p.name {
    align-self: flex-start;
  }
  .reporting_article .report .detail_con .editor p.position {
    align-self: flex-start;
  }
  .reporting_article .report .detail_con .editor a {
    right: 25px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .reporting_article .detail_con table {
    width: calc(100vw - 40px) !important;
    white-space: nowrap;
    overflow-x: scroll;
    display: block;
  }
  .reporting_article .detail_con table tbody {
    display: table;
    width: 100%;
  }
  .reporting_article .detail_con table td {
    padding: 12px 2.0vw;
    font-size: 0.80em;
  }
  .reporting_article .detail_con table td:first-child {
    padding-left: 4vw;
  }
  .reporting_article .detail_con table td:last-child {
    padding-right: 4vw;
  }
  .reporting_article .detail_con p.box {
    padding: 15px 20px;
  }
  .reporting_article .detail_con .channel {
    padding: 20px 10px;
    margin: 20px 0;
  }
  .reporting_article .detail_con .channel p {
    font-size: 0.95em;
    font-weight: 400;
    letter-spacing: -0.02em;
    line-height: 1.4em;
  }
  .reporting_article .detail_con .channel .img {
    margin: 0;
  }
  .reporting_article .detail_con .channel .img img {
    width: 34px;
  }
  .reporting_article .detail_con .channel .ctnr {
    display: inline-block;
    margin: 10px 15px 0;
  }
  .reporting_article .detail_con .channel .ctnr h6 {
    font-weight: 600;
  }
  .reporting_article .detail_con .channel .ctnr .btn {
    padding: 10px 20px;
    min-width: 88px;
  }
  .reporting_article .detail_con .channel .ctnr .btn:after {
    display: none;
  }
</style>
